<template>
  <div>
    <AssetCard />
  </div>
</template>
<script>
import AssetCard from '@/components/cards/AssetCard.vue';

export default {
  name: 'AssetDetails',
  components: {
    AssetCard
  }
};
</script>
